import { Outlet } from '@remix-run/react';
import { SideOver } from '../../components';
import { elementsColors } from '../../../util';
import { LocalThemeContextProvider } from '../../context';
import { ElementDetailViewLayoutPageCommonProps } from '../shared';

interface TaxRateElementDetailViewLayoutPageProps extends ElementDetailViewLayoutPageCommonProps {}

export function TaxRateElementDetailViewLayoutPage(sideOverProps: TaxRateElementDetailViewLayoutPageProps) {
  return (
    <SideOver {...sideOverProps} className="!px-0">
      <LocalThemeContextProvider paletteSeedColor={elementsColors['Tr']}>
        <Outlet />
      </LocalThemeContextProvider>
    </SideOver>
  );
}
